import { useCallback } from 'react';
import { useQuery } from 'react-query';
import { Group, GroupRegistrationCode } from '../@types/Members';

import { useAxios } from '../context/AxiosContext';

interface UseMemberGroupListProps {
  search?: string;
  groupRegistrationCodes?: GroupRegistrationCode;
  requiredPerm: string;
  notTermed?: boolean;
}

export function useMemberGroupList({
  search,
  groupRegistrationCodes,
  requiredPerm,
  notTermed
}: UseMemberGroupListProps) {
  const { authAxios } = useAxios();

  const fetchGroups = useCallback(
    async ({ searchTerm = undefined, groupRegistrationCodes = undefined }): Promise<Group[]> => {
      const response = await authAxios.post<any>('/groups/by/permission', {
        search: searchTerm,
        permission: requiredPerm,
        registrationCodes: groupRegistrationCodes,
        notTermed: notTermed
      });

      return response.data;
    },
    [authAxios, requiredPerm, notTermed]
  );

  const { data, status, isFetching } = useQuery(
    ['organizationsList', search, groupRegistrationCodes],
    () => fetchGroups({ searchTerm: search, groupRegistrationCodes }),
    {
      refetchOnWindowFocus: false
    }
  );

  return { values: data, isFetching, status };
}
